module.exports = __webpack_public_path__ + "img/min8.81facf06.png";